'use strict';module['exports']=function spread(_0x6868){return function _0x364d56(_0x3c5185){return _0x6868['apply'](null,_0x3c5185);};};